<div class="booking-confirmation-dialog">
  <div class="success-header">
    <mat-icon class="success-icon">check_circle</mat-icon>
    <h2>Booking Confirmed!</h2>
    <p class="success-message">Your booking has been successfully processed.</p>
  </div>

  <mat-card class="booking-details-card">
    <mat-card-header>
      <mat-card-title>Booking Details</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="booking-info">
        <div class="info-row">
          <span class="info-label">Booking ID:</span>
          <span class="info-value">{{ data.bookingId }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">Activity:</span>
          <span class="info-value">{{ data.activityName }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">Date:</span>
          <span class="info-value">{{ formatDate(data.date) }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">Time Slots:</span>
          <span class="info-value">
            @for (timeSlot of data.timeSlots; track $index) {
              <span class="time-slot-badge">{{ timeSlot }}</span>
            }
          </span>
        </div>
        
        <div class="info-row">
          <span class="info-label">Total Slots:</span>
          <span class="info-value">{{ data.totalSlots }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">Total Cost:</span>
          <span class="info-value highlight">{{ data.currency }} {{ data.totalCost.toFixed(2) }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">Customer Name:</span>
          <span class="info-value">{{ data.customerName }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">Email:</span>
          <span class="info-value">{{ data.customerEmail }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">Payment ID:</span>
          <span class="info-value payment-id">{{ data.paymentIntentId }}</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="email-notice">
    <mat-icon>email</mat-icon>
    <p>A confirmation email has been sent to <strong>{{ data.customerEmail }}</strong></p>
  </div>

  <div class="dialog-actions">
    <button mat-raised-button color="primary" (click)="onClose()">
      <mat-icon>close</mat-icon>
      Close
    </button>
  </div>
</div>











